import React, { useState } from 'react';
import { useCurrentUser } from './useCurrentUser';

export default function TenantSwitcher() {
  const { tenants, activeTenant, switchTenant, canSwitchTenant } = useCurrentUser();
  const [open, setOpen] = useState(false);

  if (!canSwitchTenant && tenants.length <= 1) return null;

  const current = tenants.find(t => t.tenantId === activeTenant);

  return (
    <div style={{ padding: '8px 16px', borderBottom: '1px solid rgba(255,255,255,0.08)', position: 'relative' }}>
      <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.45)', marginBottom: 4 }}>Active tenant</div>
      <button
        onClick={() => setOpen(o => !o)}
        style={{
          width: '100%', padding: '6px 10px', textAlign: 'left',
          background: 'rgba(255,255,255,0.05)',
          border: '1px solid rgba(255,255,255,0.1)', borderRadius: 6,
          color: '#fff', fontSize: 11, cursor: 'pointer',
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        }}>
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {current ? `${current.tenantId} (${(current.role || '').toString().toLowerCase()})` : 'Select tenant…'}
        </span>
        <span style={{ fontSize: 9 }}>{open ? '▲' : '▼'}</span>
      </button>
      {open && (
        <div style={{
          position: 'absolute', left: 16, right: 16, top: '100%', marginTop: 4,
          background: '#1B2738', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 6,
          maxHeight: 240, overflowY: 'auto', zIndex: 10,
        }}>
          {tenants.map(t => (
            <div key={t.tenantId}
              onClick={() => { setOpen(false); switchTenant(t.tenantId); }}
              style={{
                padding: '8px 10px', cursor: 'pointer', fontSize: 11, color: '#fff',
                background: t.tenantId === activeTenant ? 'rgba(3,175,255,0.15)' : 'transparent',
                borderBottom: '1px solid rgba(255,255,255,0.05)',
              }}>
              <div style={{ fontWeight: 500 }}>{t.tenantId}</div>
              <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.5)', marginTop: 2 }}>
                {(t.role || '').toString().toLowerCase()} · since {new Date(t.assignedAt).toLocaleDateString()}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
